<template>
  <div id="pie2" style="width: 100%; height: 100%"></div>
</template>

<script>
export default {
  name: "ChartPie",
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.chart = this.$echarts.init(document.getElementById("pie2"));
    window.addEventListener("resize", () => {
      if (this.chart) {
        this.chart.resize();
      }
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart(data) {
      let datas = [];
      if (data && data.length > 0) {
        data.forEach((item) => {
          datas.push({
            value: item.num,
            name:
              item.sourceType === 1
                ? "轮询订单"
                : item.sourceType === 10
                ? "线索订单"
                : "电议订单",
          });
        });
      }
      const option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "center",
          left: "right",
        },
        series: [
          {
            name: "订单信息",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            padAngle: 5,
            itemStyle: {
              borderRadius: 10,
            },
            label: {
              show: true,
              normal: {
                show: true,
                formatter: "{b} : {c} ({d}%)",
                textStyle: {
                  color: "#1f2329",
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
            },
            color: ["#d48265", "#91cc75", "#5470c6", "#ee6666", , "#91c7ae"],
            data: datas,
          },
        ],
      };
      this.chart.setOption(option);
    },
  },
};
</script>
